module.exports = __webpack_public_path__ + "static/media/Canalyticscode.961cef8d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Canalyticscode.jpeg
// module id = 109
// module chunks = 0